// extracted by mini-css-extract-plugin
module.exports = {"content":"Header_content__HUFLy","copy":"Header_copy__upR0L","fade":"Header_fade__2JC88","blur":"Header_blur__3_AnV","backdrop":"Header_backdrop__2uA07"};